import React, { useRef, useState } from "react";
import Modal from 'react-modal';
import CloseIcon from '@mui/icons-material/Close';
import { useGlobalContext } from "../../../Context/GlobalContext";
import Cookies from "js-cookie";

const VerifyFace = () => {

    const { baseUrl, selectedStaff, openToast } = useGlobalContext();
    const [isLoading, setIsLoading] = useState(false);

    const [face, setFace] = useState({
        status: selectedStaff?.staffDetails?.staff_bg_verification?.face_verification_status,
        verificationFile: selectedStaff?.staffDetails?.staff_bg_verification?.face_file
    });
    const [face1, setFace1] = useState({
        verificationFile: selectedStaff?.staffDetails?.staff_bg_verification?.face_file
    });


    async function submitFace() {
        setIsLoading(true);
        if (!face.verificationFile) {
            openToast("Please upload a face file", "warning");
            return;
        }
        // Create a new FormData instance
        const newFormData = new FormData();



        newFormData.append("verificationFile", face?.verificationFile);


        try {
            const response = await fetch(
                `${baseUrl}bg-verification/${selectedStaff.staffDetails.id}/verify/face`,
                {
                    method: "PUT",
                    headers: {
                         "Authorization": `Bearer ${Cookies.get("flowChangerAuthToken")}`
                    },
                    body: newFormData,
                    // Headers are not needed for FormData; fetch will automatically set 'Content-Type' as 'multipart/form-data'
                }
            );

            console.log("Response from backend:", response);

            if (response.ok) {  // Changed to response.ok to handle all 2xx responses
                const result = await response.json();
                console.log("Response data:", result);


                setFace({
                    status: result?.data?.face_verification_status,
                    verificationFile: result?.data?.face_file
                })

                // Show success toast and close modal
                openToast("Face successfully updated or created", "success");
                closeModal2();
            } else {
                // Show error toast if response status is not 2xx
                openToast("An error occurred while adding or updating Face", "error");
            }
        } catch (error) {
            console.error("Error submitting Face:", error);
            openToast("An error occurred while adding or updating Face", "error");
        } finally {
            setIsLoading(false);
        }
    }

    let subtitle;

    const [modalIsOpen2, setIsOpen2] = React.useState(false);
    function openModal2() {
        setIsOpen2(true);
    }
    function afterOpenModal2() {
        // references are now sync'd and can be accessed.
        subtitle.style.color = '#000';

    }

    function closeModal2() {
        setIsOpen2(false);
    }

    const fileInputRef = useRef(null);

    const handleUploadClick = () => {
        fileInputRef.current.click();
    };

    // Function to handle file selection
    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setFace({ ...face, verificationFile: file });
        if (file) {
            const fileURL = URL.createObjectURL(file); // Create a blob URL for the file
            setFace1({ ...face1, verificationFile: fileURL }); // Update state with the file URL
        }
    };

    return (
        <div className='relative flex flex-col xl:pt-[30px] w-full'>
            <div className='top-0 flex justify-between items-center bg-white pr-0 xl:pr-[0px] pb-[10px] pl-[0] w-[100%]'>
                <h3 className='font-medium'>Face Verification</h3>
                <button disabled={isLoading} className={'second-btn ' + (isLoading && 'opacity-50 cursor-not-allowed animate-pulse')} onClick={submitFace}>
                    Update Face
                </button>
            </div>

            {/* <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>UAN</h4>
                <button className='second-btn' onClick={openModal2}  >
                    Add
                </button>

            </div> */}


            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Verification Status
                </h4>
                <p className='font-light'>{face?.status}</p>

            </div>


            <div className='flex justify-between items-center border-1 bg-[#fff] shadow-cs mb-3 p-4 border rounded-lg' >
                <h4 className='font-light'>Proofs</h4>
                <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                />
                
                <div className="flex justify-center items-center bg-gray-100 border rounded-md w-[100px] h-[50px] image-container">
                    {face1?.verificationFile ? (
                        typeof face1.verificationFile === "string" ? (
                            <img
                                src={face1.verificationFile}
                                alt="Selected File"
                                className="rounded-md max-w-full max-h-full"
                            />
                        ) : (
                            <span className="text-gray-500 text-sm">Invalid file</span>
                        )
                    ) : (
                        <span className="text-gray-500 text-sm">No file</span>
                    )}
                </div>

                <button className='second-btn' onClick={handleUploadClick}>
                    Upload
                </button>

            </div>


            {/* <Modal
                isOpen={modalIsOpen2}
                onAfterOpen={afterOpenModal2}
                onRequestClose={closeModal2}
                contentLabel="Example Modal"
                className="top-[50%] bottom-auto left-[50%] absolute bg-[#fff] shadow shadow-md p-0 rounded-[10px] w-[96%] xl:w-[40%] translate-x-[-50%] translate-y-[-50%]"

            >
                <h2 ref={(_subtitle) => (subtitle = _subtitle)} className='p-3 border-b-1 text-[13px] xl:text-[15px]'>Add UAN</h2>
                <button onClick={closeModal2} className='top-[3px] right-[5px] absolute bg-[#27004a] rounded-full font-semibold'><CloseIcon className='text-white' /></button>
                <div className=''>
                    <div className='p-[10px] border border-t field-modal modal-field'>
                        <label className='font-medium text-[13px] xl:text-[14px]'>UAN
                        </label><br />
                        <input type='text' className='border-1 mt-1 mb-[10px] p-[5px] border rounded-md w-[100%] placeholder:font-font-normal text-[#000] text-[14px] focus:outline-none' value={bgVerification} onChange={(e) => setBgVerification(e.target.value)}/><br />


                    </div>
                    <div className='flex justify-end gap-[10px] pt-3 pr-[10px] pb-3 border-t'>
                        <button className='first-btn' onClick={closeModal2}>Cancel</button>
                        <button className='second-btn'>Save </button>
                    </div>
                </div>
            </Modal> */}

        </div>
    )
}

export default VerifyFace